<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Hakkımızda" />
        <AboutUs pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Feedback pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <StartWithSuccess pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import BuyNow from '../Layouts/BuyNow'
import PageTitle from '../Common/PageTitle'
import AboutUs from '../AboutFive/AboutUs'
import Feedback from '../AboutFive/Feedback'
import StartWithSuccess from '../AboutFive/StartWithSuccess'
import Footer from '../Layouts/Footer'

export default {
    name: 'AboutPageFive',
    components: {
    Navbar,
    BuyNow,
    PageTitle,
    AboutUs,
    Feedback,
    StartWithSuccess,
    Footer,
    BuyNow
},
}
</script>